import React, { useState } from "react";
import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";
import Row from "../common/List/Row";
import uniqid from "uniqid";
import {
  getLeaseRentDate,
  getOverdueState,
  getParkingSpaceNumber,
} from "../../functions/lease";
import ChakraPopUp from "../common/PopUp/ChakraPopUp";
import {
  useDisclosure,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import FeePage from "./FeePage";
import { fetchWithToken } from "../../functions/fetch";
import { useQuery } from "@tanstack/react-query";
import EditLease from "./EditLease";

const LeaseList = ({ leases, renewLease }) => {
  const titles = [
    "房號",
    "人數",
    "住戶姓名",
    "會員編號",
    "聯絡電話",
    "租約狀態",
    "租期",
    "機車位 1",
    "機車位 2",
    "汽車位",
    "備註",
  ];
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [currentLease, setCurrentLease] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);

  const defaultSubmitFunction = () => {
    console.log("default submit function, this shouldn't be called");
    onClose();
  };
  const [submitFunction, setSubmitFunction] = useState(
    () => defaultSubmitFunction,
  ); // store function in state, must use a function returning a function
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchFees = async (lease) => {
    if (!lease) {
      return [];
    }
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/lease/${lease._id}/fee`,
    );
    return res.fees;
  };

  const { data: fees } = useQuery({
    queryKey: ["fees", currentLease?._id],
    queryFn: () => fetchFees(currentLease),
    initialData: [],
  });

  return (
    <div>
      <ChakraPopUp
        isOpen={isOpen}
        onClose={onClose}
        title="編輯租約"
        onSubmit={submitFunction}
        isSubmitting={isSubmitting}
        size="4xl"
      >
        <Tabs
          align="start"
          variant="enclosed"
          index={pageIndex}
          onChange={(index) => setPageIndex(index)}
        >
          <TabList>
            <Tab>租約資訊</Tab>
            <Tab>相關費用</Tab>
          </TabList>
          <TabPanels>
            <TabPanel px={0}>
              <EditLease
                lease={currentLease}
                setSubmitFunction={setSubmitFunction}
                pageIndex={pageIndex}
                setIsSubmitting={setIsSubmitting}
                renewLease={renewLease}
              />
            </TabPanel>
            <TabPanel>
              <FeePage
                fees={fees}
                setSubmitFunction={setSubmitFunction}
                currentLease={currentLease}
                pageIndex={pageIndex}
                setIsSubmitting={setIsSubmitting}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </ChakraPopUp>
      <List gridCols="grid-cols-[repeat(10,min-content)_1fr]">
        {titles.map((title) => (
          <TitleCell
            key={uniqid()}
            className="whitespace-nowrap px-2 overflow-x-auto"
            text={title}
          />
        ))}
        {leases?.map((lease) => {
          const { room, renters, note, overdue } = lease;
          // parking space number
          const [scooterPSNum, scooterPSNum2, carPSNumber] =
            getParkingSpaceNumber(lease);

          const names = renters.map((renter) => renter.name).join(", ");
          // show the data of first renter, and show every renter info in the pop up
          const cellTexts = [
            room.roomNumber,
            renters.length,
            names,
            renters[0]?.memberNumber,
            renters[0]?.phoneNumber,
            getOverdueState(overdue),
            getLeaseRentDate(lease),
            scooterPSNum,
            scooterPSNum2,
            carPSNumber,
          ];

          const cellAlign = ["C", "C", "L", "L", "L"];
          const noteTexts = [note];
          return (
            <Row
              key={uniqid()}
              cellTexts={cellTexts}
              noteTexts={noteTexts}
              showPopUp={() => {
                setCurrentLease(lease);
                onOpen();
              }}
              cellAlign={cellAlign}
            />
          );
        })}
      </List>
    </div>
  );
};

export default LeaseList;
